import { Radio, RadioProps, withStyles } from '@material-ui/core';
import React from 'react';

const GreenRadio = withStyles({
    root: {
        color: '#33820D',
        padding: 4,
    },
})((props: RadioProps) => <Radio {...props} />);

type LabelPosition = 'top' | 'left' | 'right';

interface CustomRoundRadioProps {
    checked: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    label: string;
    value: string | number;
    name: string;
    labelPosition?: LabelPosition;
}

const CustomRoundRadio: React.FC<CustomRoundRadioProps> = ({
    checked,
    onChange,
    label,
    value,
    name,
    labelPosition = 'right',
}) => {
    const isVertical = labelPosition === 'top';
    const isLeft = labelPosition === 'left';

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: isVertical ? 'column' : 'row',
                alignItems: 'center',
                justifyContent: 'flex-start',
                cursor: 'pointer',
            }}
            onClick={() => {
                if (onChange) {
                    onChange({
                        target: {
                            value,
                            name,
                        }
                    } as React.ChangeEvent<HTMLInputElement>);
                }
            }
            }
        >
            {isLeft && <span style={{ marginRight: 8, userSelect: 'none' }}>{label}</span>}
            {isVertical && <span style={{ marginBottom: 2, userSelect: 'none', textAlign: 'center' }}>{label}</span>}
            <GreenRadio
                checked={checked}
                onChange={onChange}
                value={value}
                name={name}
                icon={
                    <span
                        style={{
                            width: 18,
                            height: 18,
                            border: '1px solid #33820D',
                            borderRadius: '50%',
                            display: 'inline-block',
                        }}
                    />
                }
                checkedIcon={
                    <span
                        style={{
                            width: 18,
                            height: 18,
                            border: '1px solid #33820D',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxSizing: 'border-box',
                        }}
                    >
                        <span
                            style={{
                                width: 12,
                                height: 12,
                                borderRadius: '50%',
                                backgroundColor: '#33820D',
                            }}
                        />
                    </span>
                }
            />
            {labelPosition === 'right' && <span style={{ marginLeft: 8, userSelect: 'none' }}>{label}</span>}
        </div>
    );
};

export default CustomRoundRadio;